import styled from "styled-components/macro";
import NavBodyItem from "../NavBodyItem";

const Container = styled.div`
  height: 100%;
  font-size: 16px;

  #dropdown-option-main-6 {
    display: none;
  }
`;

function NavigationItemMain({ data, handleOpen }: any) {
  return (
    <Container>
      <ul>
        {data.map((item: any, index: number) => {
          return (
            <NavBodyItem
              key={index}
              id={"dropdown-option-main-" + index}
              {...item}
              handleOpen={handleOpen}
            />
          );
        })}
      </ul>
    </Container>
  );
}

export default NavigationItemMain;
